"use client";
import { useEffect, useState } from 'react';

const fetchSVGContent = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const svgText = await response.text();
      return svgText;
    } catch (error) {
      console.error('Error fetching SVG:', error);
      return '';
    }
};

const SVG = ({ url }) => {
  const [svgContent, setSVGContent] = useState('');

  useEffect(() => {
    const getSVGContent = async () => {
      const content = await fetchSVGContent(url);
      setSVGContent(content);
    };

    getSVGContent();
  }, [url]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SVG;
